var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"group-videos container"},[_c('div',{staticClass:"columns is-multiline"},_vm._l((_vm.items),function(item){return _c('gv-item',{key:item.id,attrs:{"item":item}})}))])}
var staticRenderFns = []

export { render, staticRenderFns }